// Excel импортын алдааг хэрэглэгчид ойлгомжтой монгол мессеж болгож хөрвүүлэх.
export function describeImportError(err: any): string {
  // fetch abort (timeout)
  if (err?.name === 'AbortError') {
    return 'Импорт хэт удаж хугацаа хэтэрлээ. Файл том эсвэл сервер завгүй байж ' +
      'болзошгүй — файлаа цөөн мөрөөр хувааж дахин оролдоно уу.';
  }
  // "Failed to fetch" нь TypeError болж ирдэг — сервер хүрэлгүй унасан
  if (err instanceof TypeError || /failed to fetch|networkerror|load failed/i.test(err?.message || '')) {
    return 'Сервертэй холбогдож чадсангүй (Failed to fetch). Магадгүй шалтгаанууд: ' +
      '(1) интернэт холболт тасарсан, (2) файл хэт том, (3) сервер түр завгүй. ' +
      'Интернэтээ шалгаад дахин оролдоно уу; асуудал үргэлжилбэл файлаа жижиг хэсгүүдэд хуваана уу.';
  }
  return err?.message || 'Импорт хийхэд тодорхойгүй алдаа гарлаа.';
}
